import { ref } from "@vue/composition-api";

export function buildSubmitButton() {
  let submitting = ref(false);
  let submitButtonText = ref("Submit");

  return {
    submitting,
    submitButtonText,
  };
}

export function buildFormErrors() {
  let hasFormErrors = ref(false);
  let formErrors = ref<string[]>([]);

  return {
    hasFormErrors,
    formErrors,
  };
}
